import type { TranslateService } from '@ngx-translate/core';

import type { OccupancyRestrictionsInterface } from '@valk-nx/core/lib/interfaces/hotels.interface';
import type { OccupancyLabelPipe } from '@valk-nx/core/lib/pipes/occupancy-label/occupancy-label.pipe';

import type { OccupancyInterface } from '../interfaces/occupancy.interface';

export class OccupancyHelper {
	static getOccupancyString(
		occupancy: OccupancyInterface,
		translateService: TranslateService,
		occupancyLabelPipe: OccupancyLabelPipe,
	): string {
		const entries: [number, 'adults' | 'children' | 'infants'][] = [
			[occupancy.adults, 'adults'],
			[occupancy.children, 'children'],
			[occupancy.infants, 'infants'],
		];

		return entries
			.filter(([amount, key]) => key === 'adults' || amount > 0)
			.map(([amount, key]) =>
				translateService.instant(
					occupancyLabelPipe.transform(key, { amount }),
					{ amount },
				),
			)
			.join(', ');
	}

	//Check if occupancy exceeds the max persons limit and remove excess persons
	static enforceMaxPersonsLimit(
		occupancy: OccupancyInterface,
		restrictions: OccupancyRestrictionsInterface,
	): OccupancyInterface {
		let { adults, children, infants } = occupancy;
		const {
			adults: adultsRestr,
			children: childrenRestr,
			infants: infantsRestr,
			maxPersons,
		} = restrictions;

		if (maxPersons === undefined) {
			return { adults, children, infants };
		}

		while (adults + children + infants > maxPersons) {
			if (infants > infantsRestr.min) {
				infants--;
			} else if (children > childrenRestr.min) {
				children--;
			} else if (adults > adultsRestr.min) {
				adults--;
			} else {
				break;
			}
		}
		return { adults, children, infants };
	}

	static enforceCurrentOccupancyLimit(
		currentOccupancy: OccupancyInterface[],
		maxOccupancies: number,
	): OccupancyInterface[] {
		if (currentOccupancy.length > maxOccupancies) {
			return currentOccupancy.slice(0, maxOccupancies);
		}
		return currentOccupancy;
	}
}
